import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Form, Select, Typography, Grid } from "antd";
import LineSignedUpPatients from "../../components/Charts/LineSignedUpPatients";
import PieActivePatients from "../../components/Charts/PieActivePatients";
import OutRangeSelfEvaluations from "../../components/Tables/OutRangeSelfEvaluations";
import BehindUsers from "../../components/Tables/BehindUsers";
import OutRangeSelfMeasurements from "../../components/Tables/OutRangeSelfMeasurements";
import OutRangeLogBook from "../../components/Tables/OutRangeLogBook";
import MedicineRecords from "../../components/Tables/MedicineRecords";

import DashServices from "../../services/DashServices";
import { AdminContext } from "../../providers/AdminContext";

import { useNavigate } from "react-router-dom";

import { translate } from "../../locale";
import { Link } from "react-router-dom";
import { Breadcrumb, Row, Col } from "antd";

const { Title } = Typography;
const { Option } = Select;
const { useBreakpoint } = Grid;

const AdminHome = () => {
  const [values, setValues] = useState({
    period: 1,
    suscription: "",
    enterprise: "",
  });
  const [selectedData, setSelectedData] = useState(values);
  const [loadingSubscription, setLoadingSubscription] = useState(true);
  const [subscriptions, setsubscriptions] = useState([]);
  const [enterpriseLinks, setEnterpriseLinks] = useState("");
  const [enterprises, setEnterprises] = useState([]);
  const [sswitch, setsswitch] = useState(false);
  const { user } = useContext(AdminContext);
  const [isSuper, setIsSuper] = useState(null);

  const InactiveContacts = (data) => {
    if (data.type === "Inactivos" || data.type === "Inactives") {
      if (selectedData.suscription === "") {
        navigate(`/admin/users/home_inactives/${selectedData.period}`);
      } else {
        navigate(
          `/admin/users/home_inactives/${selectedData.period}/${selectedData.suscription}`
        );
      }
    }
  };
  const navigate = useNavigate();
  const screens = useBreakpoint();

  useEffect(() => {
    if (user !== null && user !== undefined) {
      setIsSuper(user.user.rol === "eira-super-admin");
      const subscriptionHome = sessionStorage.getItem("subscriptionHome");
      if (user.user.rol === "eira-super-admin" && subscriptionHome) {
        setValues((v) => ({
          ...v,
          suscription: JSON.parse(subscriptionHome),
        }));
        setsswitch(!sswitch);
      }
    }
  }, [user]);

  useEffect(() => {
    setData();
  }, [sswitch]);

  useEffect(() => {
    if (subscriptions != undefined) {
      getEnterprise();
    }
  }, [subscriptions]);

  useEffect(() => {
    getSubscriptions();
  }, []);

  const setData = () => {
    setSelectedData(values);
    getEnterprise();
  };

  const getEnterprise = () => {
    let sub = subscriptions.filter((i) => i.id === values.suscription).pop();
    if (user.user.rol !== "eira-super-admin") {
      sub = subscriptions[0];
    }
    if (
      sub &&
      (sub.enterprise?.name.indexOf("OMINT") > -1 || sub.enterprise?.id === 26)
    ) {
      setEnterpriseLinks([
        {
          title: "Informe OMINT",
          url: "https://lookerstudio.google.com/s/q7CfeB-6iYk",
          target: "_blank",
        },
        {
          title: "Informe alertas",
          url: "https://lookerstudio.google.com/s/nKDTqqkeSD4",
          target: "_blank",
        },
      ]);
    } else {
      setEnterpriseLinks([]);
    }
  };

  const getSubscriptions = async () => {
    setLoadingSubscription(true);
    try {
      let response = await DashServices.getSubscriptions(null, {
        page_size: 10000,
      });
      if (response.status >= 200 && response.status < 300) {
        setsubscriptions(response.data.subscriptions);
      }
      setLoadingSubscription(false);
    } catch (error) {
      console.log(error);
      setLoadingSubscription(false);
    }
  };

  const handleChangeSub = (e) => {
    sessionStorage.setItem("subscriptionHome", e);
    setValues((v) => ({ ...v, suscription: e }));
  };

  const handleChangePer = (e) => {
    setValues((v) => ({ ...v, period: e }));
  };

  const handleChangeEnterprise = (e) => {
    setValues((v) => ({ ...v, enterprise: e }));
  };

  const handleSuperAdminSuscriptionChange = (e) => {
    handleChangeSub(e);
    setsswitch(!sswitch);
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-6xl xxl:max-w-7xl pb-16 my-10 mx-0 lg:mx-10 px-4 lg:px-0 admin-home">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>

      <div className="flex flex-col w-full mt-4">
        <Title className="text-center !text-xl md:!text-3xl" level={2}>
          Resumen Poblacional
        </Title>

        {isSuper == true && selectedData.suscription == "" && (
          <div className="w-full mt-6 border border-solid border-custom_primary flex justify-center items-center space-y-4">
            <Form className="flex justify-center w-full">
              <Form.Item className="w-full md:w-1/4 mt-4">
                <Title className="!text-base md:!text-lg" level={4}>
                  Selecciona una suscripción
                </Title>
                <Select
                  defaultValue=""
                  onChange={handleSuperAdminSuscriptionChange}
                  className="border-custom_primary"
                  name="suscription"
                  loading={loadingSubscription}
                >
                  <Option value="">Seleccione...</Option>
                  {subscriptions !== undefined &&
                    subscriptions.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Form>
          </div>
        )}

        {((isSuper == true && selectedData.suscription !== "") ||
          isSuper == false) && (
          <div className="w-full h-auto md:h-28 mt-6 border border-solid border-custom_primary flex justify-center items-center space-y-4">
            <Form className="flex justify-center h-auto md:h-8 w-full flex-col md:flex-row p-4 md:p-0">
              {isSuper && (
                <Form.Item className="w-auto md:w-1/4 mr-0 md:mr-4">
                  <Select
                    defaultValue=""
                    onChange={handleChangeEnterprise}
                    className="border-custom_primary"
                    name="period"
                  >
                    <Option value="">Todas las empresas</Option>
                    {enterprises.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item className="w-auto md:w-1/4 mr-0 md:mr-4">
                <Select
                  defaultValue={1}
                  onChange={handleChangePer}
                  className="border border-custom_primary"
                  name="period"
                >
                  <Option value={1}>24 horas</Option>
                  <Option value={7}>7 días</Option>
                  <Option value={30}>30 días</Option>
                  <Option value={180}>6 meses</Option>
                  <Option value={365}>1 año</Option>
                </Select>
              </Form.Item>
              <Form.Item className="w-auto md:w-1/4 mr-0 md:mr-4">
                <Select
                  value={subscriptions.length > 0 ? values.suscription : ""}
                  onChange={handleChangeSub}
                  className="border-custom_primary"
                  name="suscription"
                  loading={loadingSubscription}
                >
                  {!isSuper && (
                    <Option value="">Todas las suscripciones</Option>
                  )}
                  {subscriptions !== undefined &&
                    subscriptions.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item className="mb-0 text-right md:text-left">
                <Button
                  type="primary"
                  className="bg-custom_primary"
                  onClick={() => setsswitch(!sswitch)}
                >
                  APLICAR
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
      </div>
      {((isSuper == true && selectedData.suscription !== "") ||
        isSuper == false) && (
        <>
          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 !text-base md:!text-xl">
              POBLACION TOTAL
            </Title>
          </div>

          <div className="flex flex-col md:flex-row items-stretch space-x-0 md:space-x-20 space-y-10 md:space-y-0">
            <div className="flex-1">
              <Title level={5}>Mis Pacientes Activos</Title>
              <div className="flex justify-center">
                <div className="w-8/12">
                  <PieActivePatients
                    selectedData={selectedData}
                    loadingParent={loadingSubscription}
                    onClick={InactiveContacts}
                  />
                </div>
              </div>
            </div>
            <div className="flex-1">
              <Title level={5}>Mis Pacientes Registrados</Title>

              <div className="mt-10">
                <LineSignedUpPatients selectedData={selectedData} />
              </div>
            </div>
          </div>
          {enterpriseLinks.length > 0 && (
            <div className="flex flex-row items-stretch space-x-20 mt-10">
              <div className="flex-1">
                <Title level={5}>Informes</Title>

                <div className="mt-1">
                  <Card>
                    {enterpriseLinks.map((item, key) => (
                      <Button
                        type="primary"
                        className="mr-6"
                        href={item.url}
                        target={item.targe ? item.target : "_blank"}
                        key={key}
                      >
                        {item.title}
                      </Button>
                    ))}
                  </Card>
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 !text-base md:!text-xl">
              AUTOMEDICIONES FUERA DE RANGO
            </Title>
          </div>
          <div className="flex flex-row items-stretch space-x-20">
            <div className="flex-1 overflow-x-scroll md:overflow-x-auto">
              <OutRangeSelfMeasurements selectedData={selectedData} />
            </div>
          </div>

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 !text-base md:!text-xl">
              DIARIO DE REGISTRO FUERA DE RANGO
            </Title>
          </div>
          <div className="flex flex-row items-stretch space-x-20">
            <div className="flex-1">
              <OutRangeLogBook selectedData={selectedData} />
            </div>
          </div>

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 !text-base md:!text-xl">
              MEDICAMENTOS FUERA DE RANGO
            </Title>
          </div>
          <div className="flex flex-row items-stretch space-x-20">
            <div className="flex-1 overflow-x-scroll md:overflow-x-auto">
              <MedicineRecords selectedData={selectedData} />
            </div>
          </div>

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 !text-base md:!text-xl">
              AUTOEVALUACIONES FUERA DE RANGO
            </Title>
          </div>
          <div className="flex flex-row items-stretch space-x-20">
            <div className="flex-1">
              <OutRangeSelfEvaluations selectedData={selectedData} />
            </div>
          </div>

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 !text-base md:!text-xl">
              MIS CONTACTOS ACTIVOS ATRASADOS
            </Title>
          </div>
          <div className="flex flex-row items-stretch space-x-20">
            <div className="flex-1 overflow-x-scroll md:overflow-x-auto">
              <BehindUsers selectedData={selectedData} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminHome;
